module.exports = __webpack_public_path__ + "50f2f988620f79d0be9c772cae74c473.MP3";